import React from 'react';
import { Box, Grid, Typography, Button, IconButton } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Icon } from './details.data';
import { ThemeStyle } from '../../module/ThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface IMoreDetails {
    options: Icon[];
    header: string;
    onBack: () => void;
    themeStyle: ThemeStyle;
    onClick?: (icon: Icon) => void;
}

const MoreDetails: React.FC<IMoreDetails> = ({ header, options, onBack, themeStyle, onClick }) => {
    return (
        <Box sx={{ width: '100%', flexShrink: 0, height: '500px' }}>
            <Box display="flex" alignItems="center" mb={2}>
                <IconButton style={{ color: theme[themeStyle].tag_white }} onClick={onBack}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography variant="h6" ml={1} fontFamily={FONT_ENUM.MAIN_BOLD} textTransform={'capitalize'}>
                    Add {header} Details
                </Typography>
            </Box>

            <Grid container spacing={2} wrap="wrap">
                {options.map((option, index) => (
                    <Grid item xs={12} sm={6} key={index} sx={{ display: 'flex', flexGrow: 1 }}>
                        <Button
                            startIcon={option.icon}
                            fullWidth
                            onClick={() => onClick && onClick(option)}
                            style={{
                                justifyContent: 'flex-start',
                                color: theme[themeStyle].tag_white,
                                textTransform: 'capitalize',
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                fontSize: 16,
                            }}>
                            {option.label}
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export { MoreDetails };
